import React from 'react';
import { connect } from 'react-redux';
import propTypes from 'prop-types';

import Dropdown from '../ui/Dropdown/Dropdown';

const DownloadFormats = ({ clang, lang, apiAddress, csvAddress }) => {
	const searchParams = (apiAddress && apiAddress.includes("search")) && apiAddress.split("/search/")[ 1 ];
	const getUrlDownload = (formatToDownload) => `${process.env.REACT_APP_API}/download/${formatToDownload}/${searchParams ? searchParams : 'all'}`; 

	const dict = lang[ clang ];
	const dictDropdown = dict.dropdown
	const reportErrorLabel = dict.title.error;

	const formats = ["RIS", "BibTeX", "MARC-21", "JSON"];
	const formatsList = formats.map((format) => ({
		id: format,
		label: `${dictDropdown.download_format_item} ${format}`,
		href: format === "JSON" ? apiAddress : getUrlDownload(format.toLowerCase())
	}));
	
	const reportErrorItem = [{
		id: reportErrorLabel,
		label: reportErrorLabel,
		href: dict.results.contact
	}];

	return (
			<Dropdown 
				label={ dictDropdown.download_format_label }
				dropdownListData={ formatsList.concat(reportErrorItem) }	
			/>
	);
};

DownloadFormats.propTypes = {
	clang: propTypes.string.isRequired,
	apiAddress: propTypes.string,
	csvAddress: propTypes.string,
};

const mapStateToProps = state => ({
	clang: state.language.currentLanguage,
	apiAddress: state.apiData.apiAddress,
	csvAddress: state.apiData.csvAddress,
});

export default connect(mapStateToProps)(DownloadFormats);





// WEBPACK FOOTER //
// ./src/components/formats-to-download/DownloadFormats.js